import { GetOfferDocumentsSuccessListResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';
import { Platform } from 'react-native';

import { RiskRating } from '../../../../../../../../../components/RiskRating';
import {
  FundOfferDetailEntityNormalized,
  FundOfferEntityNormalized,
} from '../../../../../../../../../store/product/types';
import { onOpenFile } from '../../../../../../../../NewApplication/utils/file';

export const formatFundsDetailsData = (data?: FundOfferDetailEntityNormalized) => {
  if (!data) {
    return [];
  }

  const parsedData = [
    { label: 'Tipo', value: data?.productCategory || '--' },
    {
      label: 'Rentabilidade 12 Meses',
      value: data?.profitabilityTwelveMonths
        ? Utils.Mask.Percentage(data?.profitabilityTwelveMonths)
        : '--',
    },
    {
      label: 'Risco',
      value: (
        <RiskRating
          currentRiskRating={data?.riskRatingLevel || 0}
          tooltip={data?.riskRating || '--'}
        />
      ),
    },
    { label: 'Investimento Inicial', value: Utils.Mask.Money(data?.participateMinimumAmount || 0) },
    { label: 'Movimentação Mínima', value: Utils.Mask.Money(data?.applicationMinimumAmount || 0) },
    {
      label: 'Taxa de Administração',
      value: data?.administrationFee ? data?.administrationFee : '--',
    },
    { label: 'Taxa de Performance', value: data?.performanceFeeDescription || '--' },
    { label: 'Resgate e Liquidação', value: data?.redemptionDescription || '--' },
    { label: '', value: '' },
  ];

  return parsedData;
};

export const formatFundsExtraDetailsData = (data?: FundOfferEntityNormalized) => {
  if (!data) {
    return [];
  }
  const extraData = [
    { label: 'Taxa de Admin.', value: data?.administrationFee || '--' },
    { label: 'Taxa de Performance', value: data?.performanceFeeDescription || '--' },
    { label: 'Investimento Inicial', value: Utils.Mask.Money(data?.participateMinimumAmount || 0) },
    { label: 'Movimentação Mínima', value: Utils.Mask.Money(data?.applicationMinimumAmount || 0) },
    {
      label: 'Rentabilidade nos Últimos 12 Meses',
      value: data?.profitabilityTwelveMonths
        ? Utils.Mask.Percentage(data?.profitabilityTwelveMonths)
        : '--',
    },
    { label: 'Aplicação', value: data?.applicationCondition || '--' },
    { label: 'Resgate e Liquidação', value: data?.redemptionDescription || '--' },
    { label: 'Resgate Antecipado', value: data?.earlyRedemptionFeeDescription || '--' },
    { label: 'Status do Fundo', value: data?.fundStatusDescription || '--' },
    {
      label: 'Horário limite para Aplicação e Resgate',
      value: data?.timeLimitToTransaction || '--',
    },
    {
      label: 'Data de Constituição do Fundo',
      value: data?.issuanceDate ? Utils.Mask.DateFormat(data?.issuanceDate, 'dd/MM/yyyy') : '--',
    },
    { label: 'Gestora', value: data?.managerName || '--' },
  ];

  return extraData;
};

export const formatDocumentList = (data?: GetOfferDocumentsSuccessListResponse | null) => {
  if (!data || !data.data || !data.data?.length) {
    return [];
  }

  const documentsList = data.data.map((item) => {
    const document = item.document;
    const fileIsBase64 = (document?.fileImage || '').length > 0;
    const file = fileIsBase64 ? document?.fileImage : document?.filePath;

    return {
      title: document?.documentTypeName || '--',
      onPress: () => Platform.OS === 'web' && onOpenFile(file || '', fileIsBase64),
    };
  });

  return documentsList;
};
